import React, { useEffect, useRef, useState } from 'react';

import { useToastAction } from '../../hooks/useToastAction.js';

import * as InteractApi from "../../api/interact.js";

import { EnvironmentGroupContext } from '..';

export const EnvironmentGroupContextProvider = ({ children }) => {
  const [ environmentGroups, setEnvironmentGroups ] = useState(null);
 
  const loadAction = useToastAction();

  // A plain variable resets on every render, so the in-flight flag lives in a ref.
  const loadingEnvironmentGroups = useRef(false);
   
  useEffect(() => {
    //console.log("EnvironmentGroupContextProvider", "useEffect[]", "calling loadEnvironmentGroups");
    loadEnvironmentGroups();
  }, []);

  useEffect(() => {
    //console.log("EnvironmentGroupContextProvider", "useEffect[environmentGroups]", "environmentGroups", environmentGroups);
  }, [environmentGroups]);

  const loadEnvironmentGroups = async (callback) => {
    if (!loadingEnvironmentGroups.current) {
      loadingEnvironmentGroups.current = true;

      try {
        //console.log("EnvironmentGroupContextProvider", "loadEnvironmentGroups");

        const groups = await InteractApi.getEnvironmentGroupsByCustomerId();
        setEnvironmentGroups(groups);

        if (!!callback)
          callback(groups);

        //console.log("EnvironmentGroupContextProvider", "loadEnvironmentGroups", "groups", groups);
      }
      finally
      {
        loadingEnvironmentGroups.current = false;
      }
      // console.log("EnvironmentGroupContextProvider", "loadEnvironmentGroups");
      // InteractApi.getEnvironmentGroupsByCustomerId().then((groups) => {
      //   setEnvironmentGroups(groups);
      //   loadingEnvironmentGroups = false;
      //   if (!!callback)
      //     callback(groups);
      //   console.log("EnvironmentGroupContextProvider", "loadEnvironmentGroups", "groups", groups);
      // });
    }
  }

  const dispatchEnvironmentGroupsReloadEvent = (callback) => {
    //console.log("EnvironmentGroupContextProvider", "dispatchEnvironmentGroupsReloadEvent", "calling loadEnvironmentGroups");
    loadEnvironmentGroups(callback);
  }

  const dispatchEnvironmentGroupsChangeEvent = (environmentGroups) => {
    setEnvironmentGroups(environmentGroups);
  }

  return (
    <EnvironmentGroupContext.Provider
      value={{
        environmentGroups,
        dispatchEnvironmentGroupsChangeEvent,
        dispatchEnvironmentGroupsReloadEvent,
      }}
    >
      {children}
    </EnvironmentGroupContext.Provider>
  );
}
